const countryPhoneNoValidation = {
  "+91": { min: 10, max: 10 },
  "+971": { min: 9, max: 9 },
  "+977": { min: 10, max: 10 },
  "+44": { min: 10, max: 10 },
  "+966": { min: 9, max: 9 },
  "+34": { min: 9, max: 9 },
  "+57": { min: 10, max: 10 },
  "+52": { min: 10, max: 10 },
  "+1": { min: 10, max: 10 },
  "+56": { min: 9, max: 9 },
  "+60": { min: 7, max: 8 },
  "+62": { min: 9, max: 11 },
  "+63": { min: 10, max: 10 },
  "+65": { min: 8, max: 8 },
  "+66": { min: 9, max: 9 },
  "+81": { min: 10, max: 10 },
  "+84": { min: 9, max: 9 },
  "+94": { min: 10, max: 10 },
  "+234": { min: 8, max: 8 },
  "+880": { min: 10, max: 10 },
  "+960": { min: 7, max: 7 },
  "+965": { min: 8, max: 8 },
  "+968": { min: 8, max: 8 },
  "+973": { min: 8, max: 8 },
  "+974": { min: 8, max: 8 },
};

export default class ValidationHelper {
  static phoneNumber(t, isdCode) {
    const min =
      (countryPhoneNoValidation[isdCode] &&
        countryPhoneNoValidation[isdCode]["min"]) ||
      10;
    const max =
      (countryPhoneNoValidation[isdCode] &&
        countryPhoneNoValidation[isdCode]["max"]) ||
      10;

    return {
      required: {
        value: true,
        message: t("common.phoneRequiredHelperText"),
      },
      minLength: {
        value: min,
        message: t("common.validPhoneHelperText"),
      },
      maxLength: {
        value: max,
        message: t("common.validPhoneHelperText"),
      },
    };
  }

  static email(t) {
    return {
      required: {
        value: true,
        message: t("common.emailRequiredHelperText"),
      },
      pattern: {
        value: /^\S+@\S+\.\S+$/,
        message: t("common.validEmailHelperText"),
      },
    };
  }

  static userName(t) {
    return {
      required: {
        value: true,
        message: t("common.requiredFieldHelperText"),
      },
    };
  }
}
